export default __webpack_public_path__ + "static/media/Welcome-CogSma-Logo.adfff9b1.svg";